<template>
  <div class="tw-w-modal-lg">
    <div class="tw-border-b tw-border-border-light tw-p-6">
      <h2 class="tw-text-xl tw-font-bold tw-text-black">
        Manage Block & Allow lists for creatives
      </h2>
    </div>
    <Tabs
      v-model="selectedTab"
      :tabs="tabs"
      class="tw-px-6"
    />
    <div class="tw-px-6 tw-pt-6 tw-text-xs">
      Type one word or expression per line.
    </div>
    <div
      v-if="selectedTab === 'blocklist'"
      class="tw-px-6"
    >
      <TextareaInput
        v-model="blocklistItems"
        :disabled="isLoading"
        rows="25"
        target-class="tw-max-h-[45vh]"
      />
      <div class="tw-text-xs">
        {{ blocklistLines > 0 ? blocklistLines : 0 }} lines
      </div>
    </div>
    <div
      v-if="selectedTab === 'allowlist'"
      class="tw-px-6"
    >
      <TextareaInput
        v-model="allowlistItems"
        :disabled="isLoading"
        rows="25"
        target-class="tw-max-h-[45vh]"
      />
      <div class="tw-text-xs">
        {{ allowlistLines > 0 ? allowlistLines : 0 }} lines
      </div>
    </div>
    <div
      v-if="error"
      class="tw-border-b tw-border-gray-500 tw-bg-red tw-p-6 tw-text-sm tw-text-white"
    >
      {{ error }}
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-p-6">
      <PassportButton
        label="Close"
        variant="basic"
        @@click="$emit('close')"
      />
      <PassportButton
        :busy="isLoading"
        variant="primary"
        :label="shouldRetry ? 'Retry' : `Save`"
        type="button"
        @@click="handleSubmit"
      />
    </div>
  </div>
</template>
<script>
import TextareaInput from '@/components/Input/TextareaInput.vue'
import PassportButton from '@/components/PassportButton.vue'
import Tabs from '@/components/Tabs.vue'

export default {
  components: { PassportButton, Tabs, TextareaInput },
  name: 'PopupCreativeBlocklist',
  props: {
    callback: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    entity: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'refreshData'],
  data() {
    return {
      allowlistItems: '',
      blocklistItems: '',
      error: null,
      isLoading: false,
      selectedTab: 'blocklist',
      shouldRetry: false,
      tabs: [
        {
          key: 'blocklist',
          label: 'Blocklist',
        },
        {
          key: 'allowlist',
          label: 'Allowlist',
        },
      ],
    }
  },
  computed: {
    blocklistLines() {
      return this.blocklistItems.split('\n').length
    },
    allowlistLines() {
      return this.allowlistItems.split('\n').length
    },
    tabItems() {
      return this.selectedTab === 'blocklist'
        ? this.blocklistItems
        : this.allowlistItems
    },
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      this.shouldRetry = false

      await Promise.all([this.fetchBlocklist(), this.fetchAllowlist()])

      this.isLoading = false
    },
    async fetchBlocklist() {
      await this.$store
        .dispatch('creativeManagement/fetchBlocklist')
        .then(() => {
          this.blocklistItems =
            this.$store.state.creativeManagement.blocklist.join('\n')
        })
        .catch((e) => {
          console.error(e)
          this.shouldRetry = true
        })
    },
    async fetchAllowlist() {
      await this.$store
        .dispatch('creativeManagement/fetchAllowlist')
        .then(() => {
          this.allowlistItems =
            this.$store.state.creativeManagement.allowlist.join('\n')
        })
        .catch((e) => {
          console.error(e)
          this.shouldRetry = true
        })
    },
    async handleSubmit() {
      this.error = null
      this.isLoading = true
      this.shouldRetry = false

      const action =
        this.selectedTab === 'blocklist' ? 'updateBlocklist' : 'updateAllowlist'

      const value =
        this.selectedTab === 'blocklist'
          ? this.blocklistItems
          : this.allowlistItems

      try {
        await this.$store.dispatch(
          `creativeManagement/${action}`,
          value.split('\n')
        )

        this.$store.dispatch('addToast', {
          type: 'info',
          value: `${this.selectedTab} successfully updated`,
        })

        await this.fetchData()
      } catch (error) {
        this.shouldRetry = true
        this.error = this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>
